import { IRequest } from "../interfaces/request";
import { IUser, IUserRequest } from "../interfaces/user";
import fetchTimeout from "../utils/fetchTimeout";
import { setHeaders, URL_REQUEST } from "./constants";

export async function loginReq(email: string, clave: string): Promise<IUserRequest> {

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({
        email,
        clave
    });

    let requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };
    let data: IUserRequest;
    try {
        // 2026-05-20: timeout subido de 4s -> 15s tras reportes de estilistas en
        // redes lentas (Arequipa) que recibían "Ocurrio un error" porque el
        // fetch abortaba antes de que el backend respondiera.
        let res = await fetchTimeout(URL_REQUEST + "/loginEmpleadoComandas", requestOptions, 15000);
        data = await res.json();
        return data;
    } catch (error: any) {
        const isTimeout = error?.message === 'timeout';
        return {
            data: null,
            status: "500",
            message: isTimeout
                ? "El servidor está tardando en responder. Verifica tu conexión a internet e intenta nuevamente."
                : "No pudimos conectar con el servidor. Revisa tu conexión a internet e intenta nuevamente."
        }
    }
}

export async function recoverPassReq(email: string): Promise<IRequest> {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({
        email
    });

    let requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    let res = await fetchTimeout(URL_REQUEST + '/recuperarClave', requestOptions, 15000);
    let data: IRequest = await res.json();
    return data;
}

export const recoverDataUser = async () => {

    let requestOptions: RequestInit = {
        method: 'GET',
        headers: setHeaders(),
        redirect: 'follow'
    };

    // 2026-05-20: timeout subido de 4s -> 15s (mismo motivo que loginReq).
    let res = await fetchTimeout(URL_REQUEST + '/api/v1/empleado', requestOptions, 15000);
    if(res.status === 500 || res.status === 404){
        throw new Error("No pudimos recuperar tus datos. Intenta nuevamente.");
    }

    let data: any = await res.json();
    let { data: user }: {data: IUser} = data;
    return user;
}
